<template>
  <el-dialog
    :visible="true"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :title="$t('Audiences_Segment_DialogMembersExportAddAttributes_Title')"
    :before-close="onClose"
  >
    <attributes-list-draggable
      v-model="attributes"
      :profile-attributes="true"
      :computed-attributes="computedAttributes && isAggregatesEnabled"
    />
    <consent-preferences-list-draggable
      v-model="preferences"
      v-if="isCMEnabled"
    />
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" plain @click="onClose">
        {{ $t('Audiences_Segment_Button_Cancel') }}
      </el-button>
      <el-button type="primary" @click="goToExport">
        {{ $t('Audiences_Segment_Button_Export') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import AttributesListDraggable from '@/modules/automations/components/AttributesListDraggable'
import ConsentPreferencesListDraggable from '@/modules/automations/components/ConsentPreferencesListDraggable'
import { $hasFeature } from '@/core/utils/VueAcl'
export default {
  name: 'MembersExportAddAttributesDialog',
  components: { AttributesListDraggable, ConsentPreferencesListDraggable },
  props: {
    computedAttributes: {
      type: Boolean,
      default: true
    },
    consentPreferences: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      attributes: [],
      preferences: []
    }
  },
  computed: {
    isAggregatesEnabled() {
      return $hasFeature('aggregatesEnabled')
    },
    isCMEnabled() {
      return $hasFeature('subscriptionPreferences') && this.consentPreferences
    }
  },
  methods: {
    onClose() {
      EventBus.$emit('export-members-add-attributes-hide')
    },
    goToExport() {
      EventBus.$emit('export-members-add-attributes-hide')
      EventBus.$emit('export-members-run-show', {
        attributes: this.attributes,
        preferences: this.preferences
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/MembersExportAddAttributesDialog.vue